module.exports = __webpack_public_path__ + "static/media/artisanconnect.cc2d9ba1.jpg";